import { extractRelativePath } from "../functions/extractRelativePath.function";
import { isPersistedPath } from "./isPersistedPath.function";

/**
 * helper function to normalize picture paths comparing to picturePathsToDelete and file
 */
export const normalizePicturePaths = (
  paths: (string | null)[] | null,
  picturePathsToDelete: string[]
): string[] | null => {
  if (!paths) return null;

  const persisted = paths
    .filter(isPersistedPath)
    .filter(path => !picturePathsToDelete.includes(path))
    .map(extractRelativePath);

  return persisted.length > 0 ? persisted : null;
};
